@if (config.layout === 'full') {

  <div class="display-content display-content--centered flex-fill">
    <div class="landing-section">
      <div class="landing-header">
        <mat-icon class="landing-icon mat-text-primary">{{ config.icon }}</mat-icon>
        <h2 class="landing-title">{{ config.title }}</h2>
        <p class="landing-description">{{ config.subtitle }}</p>
      </div>
      @if (config.suggestions.length) {
        <div class="chips-section">
          <h3 class="chips-section-title">Try these example prompts:</h3>
          <div class="chips-container">
            <mat-chip-set>
              @for (s of config.suggestions; track s) {
                <mat-chip-option class="suggestion-chip" (click)="sendSuggestion(s)">{{ s }}</mat-chip-option>
              }
            </mat-chip-set>
          </div>
        </div>
      }
    </div>
  </div>

} @else {

  <div class="d-flex flex-column align-items-center justify-content-center flex-fill gap-3 p-4 overflow-hidden w-100">
    <mat-icon class="mat-icon-xl mat-text-primary">{{ config.icon }}</mat-icon>
    <span class="mat-font-headline-sm text-center">{{ config.title }}</span>
    <span class="mat-font-body-md text-center mat-text-on-surface-variant">{{ config.subtitle }}</span>
    @if (config.suggestions.length) {
      <mat-chip-set class="w-100 mt-1">
        @for (s of config.suggestions; track s) {
          <mat-chip-option class="suggestion-chip" (click)="sendSuggestion(s)">{{ s }}</mat-chip-option>
        }
      </mat-chip-set>
    }
  </div>

}
